interface PageHeaderProps {
  eyebrow?: string
  title: string
  description: string
  icon: React.ElementType
  actions?: React.ReactNode
  meta?: React.ReactNode
}

export default function PageHeader({
  eyebrow,
  title,
  description,
  icon: Icon,
  actions,
  meta,
}: PageHeaderProps) {
  return (
    <header className='devops-page-header'>
      <div className='devops-page-header__main'>
        <span className='devops-page-header__icon' aria-hidden='true'>
          <Icon size={21} strokeWidth={1.9} />
        </span>
        <div className='min-w-0'>
          {eyebrow && <span className='devops-page-header__eyebrow'>{eyebrow}</span>}
          <h2>{title}</h2>
          <p>{description}</p>
          {meta && <div className='devops-page-header__meta'>{meta}</div>}
        </div>
      </div>
      {actions && <div className='devops-page-header__actions'>{actions}</div>}
    </header>
  )
}
